module.exports = __webpack_public_path__ + "img/ship_half.bc9fdefa.svg";